import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Breadcrumb,
  Button,
  Card,
  Modal,
  Form,
  Spin,
  Tooltip,
  Pagination,
} from 'antd';
import { Link } from 'react-router-dom';
import _ from 'lodash';

import { elipsis } from 'shared/utils/StringUtil';
import urlUtil from 'shared/utils/UrlUtil';
import { permissionService } from 'shared/services';
import NoData from 'components/NoData';
import { paginationParam, FILTER_TYPE } from 'shared/constant';
import { DeleteIcon } from 'modules/AllBillers/components/Icons';
import FormDelete from 'modules/AllBillers/components/FormDelete/FormDelete.component';

import NewFilter from 'components/NewFilter';
import text from './FormData.page.translation';
import { ENUM_TAGS } from '../../constant/AllBillerDefaultVar';
import allBillersRoute from '../../route';
import FormBuilder from './FormData.form';

import './FormList.style.less';
const { checkPermission } = permissionService;
const FormBuilderCreate = Form.create()(FormBuilder);
class FormList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isCreate: false,
      isDelete: false,
      selectedForm: {},
      formValue: {
        formName: '',
        formDescription: '',
      },
    };

    const { resetFilter, match } = this.props;
    if (!match.params.page) {
      resetFilter();
    }
  }

  componentDidMount() {
    const { match, filterValue } = this.props;
    if (match.params.page) {
      this.updateFormTable(filterValue);
    } else {
      this.updateFormTable([]);
    }
  }

  componentDidUpdate(prevProps) {
    const { formControlShow, match, filterValue } = this.props;

    if (prevProps.match.params.page !== match.params.page) {
      this.updateFormTable(filterValue);
    }

    if (prevProps.filterValue !== filterValue && !formControlShow) {
      if (
        !(
          prevProps.filterValue.length > 0 &&
          prevProps.filterValue.length > filterValue.length &&
          prevProps.filterValue[prevProps.filterValue.length - 1].inputValue
            .length === 0
        )
      ) {
        if (
          prevProps.match.params.page !== match.params.page ||
          (prevProps.match.params.page === match.params.page &&
            match.params.page > 1)
        ) {
          this._handleChangePage(1);
        } else {
          this.updateFormTable(filterValue);
        }
      }
    }
  }

  _setModalValue = (modal, form) => () => {
    this.setState({
      [modal]: true,
      selectedForm: form,
    });
  };

  _popUpModal = (modal, form) => () => {
    if (modal === 'isDelete') {
      // CHECK LINKED FORM
      this.props.checkFormToDelete(form.id, this._setModalValue(modal, form));
    } else {
      this._setModalValue(modal, form)();
    }
  };

  _onCreateSuccess = form => {
    this.setState(
      {
        isCreate: false,
        formValue: {
          formName: '',
          formDescription: '',
        },
      },
      this._handlerGoToDetail(form),
    );
  };

  _onSubmitForm = params => {
    this.props.createNewForm(params, this._onCreateSuccess);
  };

  _onDeleteSuccess = () => {
    const paginationUrl = this.buildPaginationUrl(paginationParam);
    this.props.getListForm(paginationUrl);
    this.setState({
      isDelete: false,
      selectedForm: {},
    });
  };

  _handleDelete = () => {
    const { selectedForm } = this.state;
    const { deleteForm } = this.props;
    deleteForm(selectedForm.id, this._onDeleteSuccess);
  };

  _onCloseModal = () => {
    this.setState({
      isCreate: false,
      isDelete: false,
      selectedForm: {},
      formValue: {
        formName: '',
        formDescription: '',
      },
    });
  };

  _renderModalTitle = title => (
    <Row className="modal-title-form-builder">{title}</Row>
  );

  _renderBreadCrumb = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <Row className="breadcrumb-wrapper">
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/">{formatMessage(text.home)}</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>{formatMessage(text.formsTitle)}</Breadcrumb.Item>
        </Breadcrumb>
      </Row>
    );
  };

  _handlerGoToDetail = record => () => {
    const path = allBillersRoute.FROM_DETAIL.replace(':id', record.id);
    this.props.history.push(path);
  };

  _renderCard = form => (
    <div key={`form_${form.id}`}>
      <Card className="card-list">
        <div>
          <Row className="card-title" onClick={this._handlerGoToDetail(form)}>
            <Tooltip placement="topLeft" title={form.name}>
              <span>{elipsis(form.name, 30)}</span>
            </Tooltip>
          </Row>
          <Row className="card-id">{form.public_id}</Row>
        </div>
        <Row className="card-description">
          <Tooltip placement="topLeft" title={form.description}>
            <span>{elipsis(form.description, 73)}</span>
          </Tooltip>
        </Row>
        <div className="card-tag">
          <div className="card-tag-detail">
            {form.tag_name && (
              <span className={form.tag_name.toLowerCase()}>
                {form.tag_name}
              </span>
            )}
          </div>
          {checkPermission('Form Builder:delete', true) && (
            <div
              className={`card-delete-icon ${form.tag_name}`}
              onClick={this._popUpModal('isDelete', form)}
            >
              <DeleteIcon />
            </div>
          )}
        </div>
      </Card>
    </div>
  );

  _renderCards = chunk => {
    const { length } = chunk;

    const additionalComp = [];
    let i;
    for (i = 0; i < 4 - length; i += 1) {
      additionalComp.push(
        <div className="card-list" key={`placeholder_${i}`} />,
      );
    }
    return (
      <div className="row-card" key={chunk[0].id}>
        {chunk.map(item => this._renderCard(item))}
        {additionalComp}
      </div>
    );
  };

  _renderListForm = () => {
    const { listForm, formFilter } = this.props;

    const totalItem = formFilter.page_size * formFilter.page_count;
    if (listForm.length) {
      return (
        <div>
          <div
            className="cards-wrapper-t"
            style={{ height: `${265 * Math.ceil(listForm.length / 4)}px` }}
          >
            <div className="cards-scroll">
              {_.chunk(listForm, 4).map(this._renderCards)}
            </div>
          </div>
          <div className="pagination">
            <Pagination
              total={totalItem}
              onChange={this._handleChangePage}
              pageSize={12}
              current={formFilter.page_num}
            />
          </div>
        </div>
      );
    }

    return <NoData />;
  };

  renderModalCreateForm = () => {
    const { formValue, isCreate } = this.state;
    const {
      intl: { formatMessage },
      loading,
    } = this.props;
    return (
      isCreate && (
        <Modal
          title={this._renderModalTitle(formatMessage(text.createTitle))}
          visible={isCreate}
          footer={null}
          destroyOnClose
          onCancel={this._onCloseModal}
          className="modal-create"
        >
          <FormBuilderCreate
            onSubmit={this._onSubmitForm}
            cancelFunction={this._onCloseModal}
            formValue={formValue}
            intl={this.props.intl}
            loading={loading}
          />
        </Modal>
      )
    );
  };

  renderModalDeleteForm = () => {
    const { selectedForm, isDelete } = this.state;
    const { intl, linked, loading } = this.props;

    return (
      <FormDelete
        selectedForm={selectedForm}
        isDelete={isDelete}
        linked={linked}
        intl={intl}
        loading={loading}
        onCloseModal={this._onCloseModal}
        handleDelete={this._handleDelete}
      />
    );
  };

  buildGetParamUrl = filterValue => {
    let result = '';

    filterValue.forEach(element => {
      const value = element.inputValue[0];
      switch (element.key) {
        default:
          result += `&${element.key}=${value}`;
          break;
      }
    });

    return result;
  };

  buildPaginationUrl = transactionsFilter => {
    let result = '';
    result += `page_size=${encodeURIComponent(12)}`;
    result += `&page_count=${encodeURIComponent(
      transactionsFilter.page_count,
    )}`;
    result += `&page_num=${encodeURIComponent(transactionsFilter.page_num)}`;

    return result;
  };

  updateFormTable = filterValue => {
    const { getListForm, formFilter, match, history } = this.props;

    let paginationValue = { ...paginationParam };
    let paramUrl = '';
    const page = _.get(match, 'params.page', '');
    const pageInt = parseInt(page, 10) || '';

    if (filterValue.length > 0) {
      paramUrl = this.buildGetParamUrl(filterValue);
    }

    if (page) {
      if (pageInt && pageInt >= 1) {
        paginationValue = {
          ...formFilter,
          page_num: pageInt,
        };
        const paginationUrl = this.buildPaginationUrl(paginationValue);
        getListForm(paginationUrl, paramUrl);
      } else {
        history.push(allBillersRoute.FORM_BUILDERS);
      }
    } else {
      const paginationUrl = this.buildPaginationUrl(paginationValue);
      getListForm(paginationUrl, paramUrl);
    }
  };

  _handleChangePage = page => {
    urlUtil.changePageParams(
      allBillersRoute.FORM_BUILDERS,
      page,
      this.props.history,
    );
  };

  render() {
    const {
      intl: { formatMessage },
      loading,
    } = this.props;

    const options = [
      {
        label: formatMessage(text.filter.name),
        value: 'name',
        type: FILTER_TYPE.TEXT,
      },
      {
        label: formatMessage(text.filter.pubId),
        value: 'public_id',
        type: FILTER_TYPE.TEXT,
      },
      {
        label: formatMessage(text.filter.tag),
        value: 'tag_name',
        type: FILTER_TYPE.RADIO,
        options: ENUM_TAGS.map(tag => ({
          value: tag.value.toLowerCase(),
          label: tag.value,
        })),
      },
    ];
    return (
      <div className="main-content">
        {this._renderBreadCrumb()}
        <div className="white-box-wrapper">
          <span className="title mbottom30">
            {formatMessage(text.formsTitle)}
          </span>
          {checkPermission('Form Builder:create', true) && (
            <Button
              className="btn new-form-builder-btn"
              type="primary"
              size="large"
              block
              onClick={this._popUpModal('isCreate')}
            >
              {formatMessage(text.createTitle)}
            </Button>
          )}

          <NewFilter options={options} />
          <Row className="form-builder-list-wrapper">
            <Spin spinning={loading}>{this._renderListForm()}</Spin>
          </Row>
        </div>
        {this.renderModalCreateForm()}
        {this.renderModalDeleteForm()}
      </div>
    );
  }
}

FormList.propTypes = {
  intl: PropTypes.object,
  listForm: PropTypes.arrayOf(PropTypes.object),
  formFilter: PropTypes.object,
  linked: PropTypes.bool,
  loading: PropTypes.bool,
  getListForm: PropTypes.func,
  checkFormToDelete: PropTypes.func,
  createNewForm: PropTypes.func,
  deleteForm: PropTypes.func,
  resetFilter: PropTypes.func,
  filterValue: PropTypes.array,
  history: PropTypes.object,
  match: PropTypes.object,
  formControlShow: PropTypes.bool,
};

export default FormList;
